function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o);
}
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t)
    return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i))
        return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
} return ("string" === r ? String : Number)(t); }
/**
 * Configuration Constants - Frontend constants for configuration management
 */
export var CONFIGURATION_TYPES = {
    SYSTEM: 'System',
    USER_EXPERIENCE: 'UserExperience',
    APP_CONFIGURATION: 'AppConfiguration',
    DB_CONFIGURATION: 'DBConfiguration',
    SYSTEM_PROTECTED_READ_ONLY: 'SystemProtectedReadOnly'
};
import { constants } from '../constants';
export var CONFIGURATION_TYPE_LABELS = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, CONFIGURATION_TYPES.SYSTEM, constants.configuration_type_system), CONFIGURATION_TYPES.USER_EXPERIENCE, constants.configuration_type_user_experience), CONFIGURATION_TYPES.APP_CONFIGURATION, constants.configuration_type_app_configuration), CONFIGURATION_TYPES.DB_CONFIGURATION, constants.configuration_type_db_configuration), CONFIGURATION_TYPES.SYSTEM_PROTECTED_READ_ONLY, constants.configuration_type_system_protected_read_only);
export var VALUE_TYPES = {
    STRING: 'string',
    NUMBER: 'number',
    BOOLEAN: 'boolean',
    OBJECT: 'object'
};
export var VALUE_TYPE_LABELS = _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, VALUE_TYPES.STRING, constants.configuration_value_type_text), VALUE_TYPES.NUMBER, constants.configuration_value_type_number), VALUE_TYPES.BOOLEAN, constants.configuration_value_type_boolean), VALUE_TYPES.OBJECT, constants.configuration_value_type_json_object);
